import { FC, useEffect } from 'react'
import { GetServerSideProps } from 'next'

import OsteoporosisPage from 'components/program/osteoporosis/osteoporosis'

import A from 'utils/metrics/analytic'
import nestRequest from 'utils/server-side/nestRequest'
import { go404 } from 'utils/redirect'
import { ICourseType } from 'constants/types/course.types'
import { Pathname } from 'constants/data'

interface ICoursePage {
  course: ICourseType
}

const courseId = 2

const CoursePage: FC<ICoursePage> = ({ course }) => {
  useEffect(() => A.setCourseOpen(course.id), [course.id])
  return <OsteoporosisPage course={course} />
}

export const getServerSideProps: GetServerSideProps = async (context) => {
  let course = {} as ICourseType

  try {
    const restRet = await nestRequest(context, 'get', `/api/nmoCourse/${courseId}`, {})
    course = restRet?.data

    if (course.available) {
      return {
        redirect: {
          destination: `/${Pathname.NMO_COURSE}/${course.linkTranslation}`,
          statusCode: 307,
        },
      }
    }

    return {
      props: {
        course,
      },
    }
  } catch (err) {
    console.warn(err)
    return go404()
  }
}

export default CoursePage
